import script from "./TaskDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetails.vue?vue&type=script&setup=true&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=b6fa632a&lang=css"

const __exports__ = script;

export default __exports__